var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeUp = function SvgVolumeUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m10.956 2.466-3.651 3.54a1.5 1.5 0 0 1-1.044.423H3a1.5 1.5 0 0 0-1.5 1.5v7.714a1.5 1.5 0 0 0 1.5 1.5h3.232a1.5 1.5 0 0 1 1.079.457l3.61 3.734c.938.97 2.579.306 2.579-1.043V3.543c0-1.325-1.593-2-2.544-1.077M12 3.543v16.748l-3.611-3.734a3 3 0 0 0-2.157-.914H3V7.929h3.26a3 3 0 0 0 2.089-.846z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.976 17.428c.292.292.77.294 1.038-.022a9 9 0 0 0 0-11.624c-.268-.316-.746-.315-1.038-.022s-.29.766-.027 1.086a7.5 7.5 0 0 1 0 9.496c-.263.32-.266.793.026 1.085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.854 15.306c.293.293.773.295 1.027-.031a6 6 0 0 0 0-7.362c-.254-.327-.734-.324-1.027-.031-.293.292-.286.764-.046 1.102a4.5 4.5 0 0 1 0 5.22c-.24.337-.247.81.046 1.102"
  })));
};
export default SvgVolumeUp;